import { render, staticRenderFns } from "./NoButton.vue?vue&type=template&id=e2a3ebde&scoped=true"
import script from "./NoButton.vue?vue&type=script&lang=js"
export * from "./NoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a3ebde",
  null
  
)

export default component.exports